import { createRoot } from 'react-dom/client';

import { AppProvider } from './shared/providers/AppProvider';

const renderApp = () => {
    const root = createRoot(document.getElementById('app') as HTMLElement);
    root.render(<AppProvider />);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderApp);
} else {
    renderApp();
}
